import {
  Inserter,
  SessionRole,
  DragAndDropContext,
  TinymcePortal,
  RouterPageNotFound,
  ErrorBoundry,
  PartAdmin,
  PartMenu,
  Wrapper,
  Icon,
  Link,
} from "nystem-components";

import "./index.css";

const Index = () => (
  <ErrorBoundry fallback={<Inserter match="*" source="/page/view/404" />}>
    <DragAndDropContext>
      <TinymcePortal />
      <SessionRole userrole="logged-in">
        <Wrapper className="flex flex-col justify-center items-center ">
          <Link to="/admin">
            <Icon
              icon="gear"
              className="fixed top-0 right-0 w-8 h-8 text-gray-500 z-200 p-2"
            />
          </Link>
        </Wrapper>
      </SessionRole>
      <Wrapper className="font-body text-hepard-dark-gray antialiase bg-hepard-light-gray">
        <PartMenu />
        <PartAdmin />
        <Inserter match="/" source="/content/front/front1st" />
        <Inserter
          match="/"
          source="/content/news/front2nd"
          className="bg-white"
        />
        <Inserter
          match="/"
          source="/news/front"
          className="bg-white pb-10 md:pb-20"
        />
        <Inserter match="/" source="/content/front/front3rd" />
        <Inserter
          match="/page/view/*"
          className="px-8 py-12 mx-auto max-w-3xl"
        />
        <Inserter
          match="/partner/view/*"
          className="px-8 py-12 mx-auto max-w-3xl"
        />
        <Inserter match="/news" source="/news/page" className="-mt-10" />
        <RouterPageNotFound limit={3}>
          <Inserter
            match="*"
            source="/page/view/404"
            className="px-8 py-12 mx-auto max-w-3xl"
          />
        </RouterPageNotFound>
        <Inserter
          match="*"
          source="/content/footer/footer"
          className="footer"
        />
      </Wrapper>
    </DragAndDropContext>
  </ErrorBoundry>
);

export default Index;
